
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 8a7 7 0 017-7h24a7 7 0 017 7v14.293a7 7 0 01-7 7H20.442L10.72 39v-9.707H8a7 7 0 01-7-7V8z","fill":"#1BB58B"}}),_c('rect',{attrs:{"x":"7.65","y":"10","width":"24.7","height":"3","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"7.65","y":"16","width":"18.05","height":"3","rx":"1","fill":"#fff"}})])
          )
        }
      }
    